var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',{staticClass:"trip-settings trip-settings__fieldset trip-settings__fieldset_selects"},[[(_vm.showRestaurantsFilter)?_c('restaurants-filter'):_vm._e()]],2)}
var staticRenderFns = []

export { render, staticRenderFns }